import { TranslationStatus, TranslationStatusStrings } from "../store/slices/translationsSlice";

// Helper function to get all translation statuses
export const getTranslationStatuses = (): TranslationStatus[] => {
    return Object.values(TranslationStatus);
};

// Helper function to get all filter statuses
export const getFilterStatuses = (): { key: TranslationStatus; label: string }[] => {
    return [
        ...getTranslationStatuses().map(status => ({
            key: status,
            label: TranslationStatusStrings[status],
        })),
    ].filter(statusObj => statusObj.key !== TranslationStatus.DEACTIVATED);
};
